import { FilerrUploader } from '@fiverr-private/filerr_uploader/src';

/**
 * @param {object} filerrUploaderOptions - Filerr uploader options
 * @returns {object} A new instance of filerr uploader.
 */
const createFilerrUploader = (filerrUploaderOptions) => new FilerrUploader(filerrUploaderOptions);

export default createFilerrUploader;
